import { Button } from '@atlas/components';
import {
  type ComponentProps,
  type FC,
  type MouseEventHandler,
  type ReactNode,
  useCallback,
} from 'react';

import Link from 'components/Link';
import { useConfig } from 'config';
import { usePopups } from 'store';
import { Translation } from 'utils/translations';

type DepositButtonProps = {
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  children?: ReactNode;
} & Omit<ComponentProps<typeof Button>, 'onClick'>;

const DepositButton: FC<DepositButtonProps> = ({
  className,
  onClick,
  children,
  ...buttonProps
}) => {
  const quickDepositEnabled = useConfig(
    'config.siteConfig.payments.quickDeposit',
  );
  const { addPopup } = usePopups();

  const handleDepositClick = useCallback<MouseEventHandler<HTMLAnchorElement>>(
    (e) => {
      if (quickDepositEnabled) {
        e.preventDefault();
        addPopup({
          type: 'default',
          contentType: 'quickDeposit',
          immediate: true,
        });
      }
      onClick?.(e);
    },
    [quickDepositEnabled, addPopup, onClick],
  );

  return (
    <Link
      to="/account/payment/deposit"
      className={className}
      onClick={handleDepositClick}
      data-testid="deposit-button"
    >
      {children || (
        <Button wide {...buttonProps}>
          <Translation message="deposit_button" />
        </Button>
      )}
    </Link>
  );
};

export default DepositButton;
